// export const PROD_URL = "http://31.220.107.38:9000";
// export const PROD_URL = "https://dev.jiitu.co.id";
export const PROD_URL = "https://piawaindonesia.id";
export const DEV_URL = "http://localhost:8000";